import React from 'react'
import { ElementProps } from '../models'
import FieldLabel from './FieldLabel'
import ErrorMessage from './ErrorMessage'

const NumberField = ({
  component,
  state,
  handleChange,
  disabled,
  errorMessage,
}: ElementProps) => {
  return (
    <div className='fieldSet'>
      <FieldLabel label={component.label} required={component.required} />
      <div>
        <input
          type='number'
          value={state[component.reference] || ''}
          onChange={(e) => handleChange(e.target.value, component)}
          name={component.reference}
          disabled={disabled}
          style={errorMessage ? { borderColor: 'red' } : {}}
        />
        <ErrorMessage errorMessage={errorMessage} />
      </div>
    </div>
  )
}

export default NumberField
